import { useState } from 'react';
import { supabase } from './supabase';

// Magic link rather than a password: the admin's existing account already carries a real email
// address, so an OTP to it signs into that same auth user — one account across both surfaces, no
// identity linking, no password to leak or reset (ADR 0036).
export default function SignIn() {
  const [email, setEmail] = useState('');
  const [sent, setSent] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [sending, setSending] = useState(false);

  async function submit(event: React.FormEvent) {
    event.preventDefault();
    setSending(true);
    setError(null);
    const { error: otpError } = await supabase.auth.signInWithOtp({
      email: email.trim(),
      options: { emailRedirectTo: window.location.origin },
    });
    setSending(false);
    if (otpError) setError(otpError.message);
    else setSent(true);
  }

  if (sent) {
    return (
      <main className="centered">
        <h1>Check your email</h1>
        <p>
          A sign-in link is on its way to <strong>{email.trim()}</strong>. Open it on this device —
          the link carries the session, so it has to land in this browser.
        </p>
      </main>
    );
  }

  return (
    <main className="centered">
      <h1>Admin Console</h1>
      <form onSubmit={submit}>
        <label htmlFor="email">Email</label>
        <input
          id="email"
          type="email"
          required
          autoFocus
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          placeholder="you@example.com"
        />
        <button type="submit" disabled={sending || email.trim() === ''}>
          {sending ? 'Sending…' : 'Send sign-in link'}
        </button>
      </form>
      {error && <p className="error">{error}</p>}
    </main>
  );
}
